import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/62/thumb-landscape.jpg"

const Post62 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        Maison Margiela／5AC<br></br>
        ミディアム：W35× H23× D17 (cm)／マイクロ：W22× H15× D10 (cm)／ミニ：W26× H18× D13 (cm)
      </span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>12月。<br></br>ニットやブーツが主役になる季節、装いがぐっとシックに変わるこの時期は、バッグも“衣替え”のタイミングです。トレンドに左右されず、自分らしさを引き立ててくれるアイテムを選びたい——そんな大人の女性たちの間で、今季も圧倒的な支持を集めているのがMaison Margiela（メゾン マルジェラ） の「5AC（ファイブエーシー）」です。</p>
          <p>ブランドを象徴する“デコンストラクション＝再構築”の美学を体現したこのバッグは、エレガントでありながらどこかアンニュイ。オン・オフどちらにも寄り添う万能さで、冬の街にしっくり馴染む一本です。</p>
          <p>今回は、そんなマルジェラの名品「5ACマイクロ」「5ACミニ」「5ACミディアム」の3サイズを比較しながら、冬コーデにおすすめの選び方を紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;メゾン マルジェラ「5AC」とは？</ScrollLink><br></br>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;マルジェラ5AC｜デザインの特徴</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜カレンダータグ付きライニング</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜「4ステッチ」</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜3WAY仕様</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜南京錠とキーチャーム</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜底スタッズ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜バッグサイズによる開閉部分の違い</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;5AC｜ショルダーストラップの違い</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;サイズ比較：マイクロ／ミニ／ミディアム</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec11" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;【5AC マイクロ】サイズ：W22× H15× D10 (cm)
</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec12" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;【5AC ミニ】サイズ：W26× H18× D13 (cm)
</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec13" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;【5AC ミディアム】サイズ：W35× H23× D17 (cm)
</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec14" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;マルジェラ＝ブラック？ 冬に映える淡色カラー</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec15" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;同じ5ACでも、カラーで印象は大きく変わる</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec16" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;淡いブルーの「5AC」でつくる、冬コーデ</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec17" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;まとめ：あなたにぴったりの「5AC」は？</ScrollLink><br></br>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/62/1.jpg" alt=""/>
          <span className="text-center">
            Maison Margiela／5AC<br></br>
            マイクロ：W22× H15× D10 (cm)／ミディアム：W35× H23× D17 (cm)／ミニ：W26× H18× D13 (cm)
          </span>
        </figure>
        <div className="mt8">
          <h2>メゾン マルジェラ「5AC」とは？</h2>
        </div>
        <p>1988年にベルギー出身のデザイナー、マルタン・マルジェラによってパリで設立されたファッションブランドです。</p>
        <p>「5AC（ファイブエーシー）」は、2016年の登場以来、マルジェラを代表するアイコンバッグとして愛され続けているシリーズです。名前の“5AC”は、フランス語で“sac（バッグ）”を逆さにした言葉遊びからきています。その名の通り、“既存の概念をひっくり返す”というマルジェラらしいウィットが込められています。</p>
        <p>クラシックなボストンフォルムをベースにしながら、ライニングを外に出した“裏返し”のデザインや、上質なグレイン素材に、ブランドを象徴するホワイトステッチのタグが特徴です。静かで知的な個性を放つこのバッグは、持つ人の感性を際立たせてくれます。</p>
        <p>そして今、5ACは世界中のファッションアイコンやエディター、感度の高い人たちに選ばれるバッグとしても知られています。トレンドに流されず、ひと目で“上質さ”と“個性”が伝わるデザインは、持つ人のセンスそのものを映し出してくれます。街で5ACをさりげなく持つ人は、どこか余裕があり、モードを日常に溶け込ませる上級者です。</p>
        <p>そんなイメージも、このバッグの人気を後押ししています。</p>
      </section>
      <section name="sec2" className="section-content">
        <div>
          <h2>マルジェラ5AC｜デザインの特徴</h2>
        </div>
        <p>唯一無二のハイセンスなデザインで人気を集める5ACのバッグ。<br></br>
        ファッション性が高く、女性のみならず男性からも支持を集めるこだわりが詰まったデザインです。<br></br>
        そんな5ACバッグで特にポイントとなるデザインの特徴をご紹介します。</p>
        <div name="sec3" className="mt8">
          <div>
            <h3>◆ 5AC｜カレンダータグ付きライニング</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/2.jpg" alt=""/>
            <span className="text-center">カレンダータグ</span>
          </figure>
          <p>マルジェラの「11」という数字は、アクセサリーのラインを意味しています。<br></br>
          これは、マルジェラの数あるラインの中でもユニセックスに対応するアイテム群であり、男女問わず楽しめることが特徴です。マルジェラは、ファッションの既成概念に挑戦し続けるブランドとして知られており、11番のアクセサリーもその精神を感じさせます。</p>
          <p>数字11が示すアイテムは、バッグや財布など、普段使いしやすいものが多く揃っています。<br></br>
          例えば、ナンバリングリングやシンプルなデザインのバッグが定番です。これらは、無駄のない洗練されたデザインを持ち、スタイルを問わず取り入れやすいことが魅力です。</p>
          <div className="img-two-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/3.jpg" alt=""/>
              <span className="text-center">ライニング：上部に引き出した状態</span>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/4.jpg" alt=""/>
              <span className="text-center">ライニング：中に入れた状態</span>
            </figure>
          </div>
          <p>5ACバッグを見たときに、まず目を引く特徴的なデザインといえば「カレンダータグ付きのライニング」です。こちらのライニングは、上部に引き出した状態と中に入れた状態ではバッグの雰囲気が異なり、まったく別の表情を見せてくれるのがとてもユニークです。ライニングを上部に引き出した状態ならカジュアルコーディネートにも映え、デイリー使いに適したお洒落な印象になります。ライニングを中に入れた状態ならフォーマルの場でも使いやすいシンプルバッグに変身します。</p>
        </div>
        <div name="sec4" className="mt8">
          <div>
            <h3>◆ 5AC｜「4ステッチ」</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/5.jpg" alt=""/>
            <span className="text-center">「4ステッチ」</span>
          </figure>
          <p>マルジェラを象徴するディテールのひとつが、バッグ背面に施された「4ステッチ」です。</p>
          <p>ブランドロゴをあえて見せず、縫い目だけで存在を示すこのデザインには、「ブランド名に頼らず、質の高さで語る」という〝匿名性〟の美学が込められています。</p>
          <p>見る人が見ればすぐにわかる、控えめながら確かなアイコン。</p>
          <p>主張しすぎない上品さが、ファッション感度の高い人々を惹きつけています。コンサバティブなスタイルにも自然に溶け込み、装いにさりげないセンスを添えてくれる点も人気の理由です。</p>
        </div>
        <div name="sec5" className="mt8">
          <div>
            <h3>◆ 5AC｜3WAY仕様</h3>
          </div>
          <div className="img-two-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/6.jpg" alt=""/>
              <span className="text-center">ハンドスタイル</span>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/7.jpg" alt=""/>
              <span className="text-center">ショルダースタイル</span>
            </figure>
          </div>
          <h4 className="mt4"><span className="text-border-bottom">クラシックに持つ、“ハンドスタイル”</span></h4>
          <p>まず、もっともベーシックで美しいのがハンドル持ちです。<br></br>
          トップハンドルは、丸みを帯びた上質な素材で仕立てられており、手にしっとりと馴染む感触が特徴です。フォーマルな印象を与えつつ、どこか柔らかさを感じさせるマルジェラ特有のバランス感が素敵です。</p>
          <h4><span className="text-border-bottom">アクティブに楽しむ、“ショルダースタイル／クロスボディスタイル”</span></h4>
          <p>5ACには、取り外し可能なショルダーストラップが付属しています。<br></br>
          斜めがけすれば、ぐっとカジュアルでこなれた印象に変わります。この“抜け感”こそ、今のファッションに欠かせないポイントです。</p>
        </div>
        <div name="sec6" className="mt8">
          <div>
            <h3>◆ 5AC｜南京錠とキーチャーム</h3>
          </div>
          <div className="img-two-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/8.jpg" alt=""/>
              <span className="text-center">南京錠</span>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/9.jpg" alt=""/>
              <span className="text-center">キーチャーム</span>
            </figure>
          </div>
          <p>マルジェラはこの南京錠に、“本質を隠す＝メゾンの匿名性”という意味を込めています。<br></br>
          ブランドロゴを大きく見せることなく、代わりに無言のアイコンとして存在させる——それが、メゾン マルジェラらしい「静かな主張」です。</p>
          <p>マルジェラのアトリエでは、職人の手によって一点一点丁寧にメタルパーツが磨き上げられています。ゴールド、シルバー、ブラックなど、バッグのカラーや素材に合わせて異なる仕上げが施され、持つ人のスタイルにそっと寄り添う輝きを放ちます。</p>
          <p>南京錠と対になるのが、キーチャーム。<br></br>
          しなやかなコードで丁寧に包まれたキーが、バッグの片側にさりげなく添えられています。<br></br>
          細部まで完璧に計算されたパーツたちは、マルジェラが信じる「デザインとは、語らずして語るもの」という思想をまさに体現しています。</p>
          <p>派手さよりも、手にしたときにだけ分かる“質感の説得力”が、ブランドの真骨頂です。</p>
        </div>
        <div name="sec7" className="mt8">
          <div>
            <h3>◆ 5AC｜底スタッズ</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/10.jpg" alt=""/>
            <span className="text-center">バッグ側面</span>
          </figure>
          <p>こちらは、底に並んだスタッズ。<br></br>
          よく見ると、同じ形ではなく、あえて異なるデザインを組み合わせているのが印象的です。</p>
          <p>ジョン・ガリアーノ氏が率いる新生メゾン マルジェラならではの、遊び心とこだわりが詰まった「5AC」シリーズ。</p>
          <p>マルジェラのバッグには随所に緻密なデザイン哲学が感じられますが、こうした細部の工夫に目を向けると、より一層その個性と美学を堪能できます。</p>
        </div>
        <div name="sec8" className="mt8">
          <div>
            <h3>◆ 5AC｜バッグサイズによる開閉部分の違い</h3>
          </div>
          <div className="img-two-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/11.jpg" alt=""/>
              <span className="text-center">マイクロ：ボタン2点留め</span>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/12.jpg" alt=""/>
              <span className="text-center">ミニ：ジップ開閉式</span>
            </figure>
          </div>
          <p>5ACではサイズによって仕様の違いもあるので事前チェックが必須◎ </p>
          <h4 className="mt4">【マイクロ】ボタン2点留め仕様</h4>
          <p>ジップがない分、開閉がスムーズで、必要なものをさっと取り出せる軽快さが魅力です。</p>
          <h4>【ミニ】ジップ開閉式</h4>
          <p>開け閉めしやすいファスナー構造で、見た目のスマートさと防犯性を両立しています。</p>
          <h4>【ミディアム】ジップ開閉式</h4>
          <p>ミニと同様に開け口がしっかりしており、荷物の多い日も安心して使える構造です。</p>
        </div>
        <div name="sec9" className="mt8">
          <div>
            <h3>◆ 5AC｜ショルダーストラップの違い</h3>
          </div>
          <div className="img-two-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/13.jpg" alt=""/>
              <span className="text-center">マイクロ：細めのチェーンストラップ </span>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/62/14.jpg" alt=""/>
              <span className="text-center">ミニ：しなやかな質感のストラップ</span>
            </figure>
          </div>
          <p>5ACではサイズによって仕様の違いもあるので事前チェックが必須◎ </p>
          <h4 className="mt4">【マイクロ】細めのチェーンストラップが付属</h4>
          <p>チェーンは軽やかで、まるでジュエリーのような繊細な輝きを放ちます。コンパクトなフォルムと相まって、持つだけでスタイリングに華やぎを添えてくれる存在です。チェーンストラップなのでパーティシーンにもぴったりです。</p>
          <h4>【ミニ】しなやかな質感のストラップが付属</h4>
          <p>長さの調整と取り外しが可能で、ハンド・ショルダー・クロスボディの3WAYで使えます。デイリーからお出かけまで幅広いシーンに対応し、シンプルな装いにモードなエッセンスを加えてくれます。ストラップを外せば、上品なハンドバッグとしても活躍します。</p>
          <h4>【ミディアム】しなやかな質感のストラップが付属</h4>
          <p>長さ調整・取り外しができるため、荷物が多い日も快適に持ち運べます。ハンド・ショルダー・クロスボディの3WAY仕様で、シーンに合わせた使い分けが可能です。</p>
        </div>
      </section>
      <section name="sec10" className="section-content">
        <div className="img-three-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/62/15.jpg" alt=""/>
            <span className="text-center">マイクロ<br></br>W22× H15× D10 (cm)</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/62/16.jpg" alt=""/>
            <span className="text-center">ミニ<br></br>W26× H18× D13 (cm)</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/62/17.jpg" alt=""/>
            <span className="text-center">ミディアム<br></br>W35× H23× D17 (cm)</span>
          </figure>
        </div>
        <div className="mt8">
          <h2>サイズ比較：マイクロ／ミニ／ミディアム</h2>
        </div>
        <p>ここからは、それぞれのサイズ感と魅力を詳しく見ていきましょう。</p>
        <div name="sec11" className="mt8">
          <div>
            <h3>◆ 【5AC マイクロ】サイズ：W22× H15× D10 (cm)</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/18.jpg" alt=""/>
          </figure>
          <p>「マイクロ」は名前の印象ほど小さくなく、スマートフォン、ミニ財布、リップなど必要最低限のものをスマートに収納できます。ショルダーストラップ付きで、斜めがけにも対応している便利な3WAY仕様です。</p>
          <p>休日のカフェや、デート、ちょっとしたお出かけにぴったり。</p>
          <p>マルジェラの遊び心を感じながら、軽やかに持てるのがこのサイズの魅力です。</p>
        </div>
        <div name="sec12" className="mt8">
          <div>
            <h3>◆ 【5AC ミニ】サイズ：W26× H18× D13 (cm)</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/19.jpg" alt=""/>
          </figure>
          <p>人気No.1の「ミニ」は、日常使いしやすい絶妙なバランス。<br></br>
          長財布やスマホ、ポーチ、キーケースなどを収納しても余裕があり、見た目以上の実用性があります。</p>
          <p>オフィスから休日まで、どんなシーンにもマッチし、コーディネートの主役になる存在感を放ちます。小さすぎず大きすぎないサイズ感が、多くのファッションエディターに支持されている理由です。</p>
        </div>
        <div name="sec13" className="mt8">
          <div>
            <h3>◆ 【5AC ミディアム】サイズ：W35× H23× D17 (cm)</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/20.jpg" alt=""/>
          </figure>
          <p>「ミディアム」は、きちんと感と収納力を兼ね備えた頼れる存在。<br></br>
          A4こそギリギリ入らないものの、長財布やポーチ、手帳、ストールまでしっかり収納できます。</p>
          <p>仕事や出張、マザーズバッグ的な使い方にも対応できる容量が魅力です。<br></br>
          上質な素材の質感と構築的なフォルムが冬のコートスタイルに映え、「存在感のあるバッグを日常に取り入れたい」という大人の女性におすすめです。</p>
        </div>
      </section>
      <section name="sec14" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/62/21.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>マルジェラ＝ブラック？ 冬に映える淡色カラー</h2>
        </div>
        <p>冬のコーディネートは、アウターやニットなど“素材の重さ”が増える季節です。<br></br>
        そんなときこそ、バッグで軽やかさを演出することが大人の上級テクニックです。</p>
        <p>マルジェラの5ACは、素材の質感がしなやかでフォルムも洗練されているため、見た目が重たくなりません。どのサイズを選んでも服とのバランスがとりやすく、多くのファッションエディターに支持されています。</p>
        <p>特に12月は、ダークトーンのアウターが増える季節です。<br></br>
        そんな装いにブルーやベージュの5ACを合わせるだけで、ぐっと抜け感のある印象になります。<br></br>
        “重さと軽やかさのバランス”をつくるアイテムとして、この冬も注目を集めています。</p>
        <div name="sec15" className="mt8">
          <div>
            <h3>◆ 同じ5ACでも、カラーで印象は大きく変わる</h3>
          </div>
          <ul className="list-style-disc">
            <li><span className="text-font-bolder">ピンク</span>：モードで知的、どんな装いにもマッチ</li>
            <li><span className="text-font-bolder">ブルー／ベージュ</span>：柔らかく上品、冬のニュアンスカラーに最適</li>
            <li><span className="text-font-bolder">アイボリー</span>：冬の街に映えるクリーンな存在感</li>
            <li><span className="text-font-bolder">ゴールド／シルバー</span>：アクセサリー感覚で持てるトレンドカラー</li>
            <li><span className="text-font-bolder">ブラック</span>：シックで端正、どんなシーンにも寄り添う万能カラー</li>
            <li><span className="text-font-bolder">ブラウン</span>：深みがあり、冬の装いに温もりを添えるクラシックな印象</li>
          </ul>
        </div>
        <div name="sec16" className="mt8">
          <div>
            <h3>◆ 淡いブルーの「5AC」でつくる、冬コーデ</h3>
          </div>
          <figure>
            <StaticImage src="../../images/posts/62/22.jpg" alt=""/>
          </figure>
          <p>ふんわりとしたグレーのニットセットアップに、ブラックのノーカラーコートを重ねたスタイリングです。</p>
          <p>そこに、淡いブルーの「5AC」を合わせることで、全体が軽やかで女性らしい印象に仕上がります。</p>
          <p>主張しすぎないペールトーンのブルーは、冬の装いに透明感をプラスしてくれる万能カラー。</p>
          <p>重たくなりがちな季節のコーデも、ぐっと垢抜けて見せてくれます。<br></br>
          カジュアルにもきれいめにもマッチする5ACなら、休日のランチからオフィスシーンまで幅広く活躍します。</p>
        </div>
      </section>
      <section name="sec17" className="section-content">
        <div className="table-wrap">
          <table className="table table--col">
            <thead>
              <tr>
                <th>サイズ</th>
                <th>印象</th>
                <th>収納力</th>
                <th>シーン</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>マイクロ<br></br>W22 × H15 × D10 (cm)</td>
                <td>コンパクトで可憐</td>
                <td>★☆☆</td>
                <td>休日・デート・お出かけ</td>
              </tr>
              <tr>
                <td>ミニ<br></br>W26 × H18 × D13 (cm)</td>
                <td>バランスがよく万能</td>
                <td>★★☆</td>
                <td>デイリー・通勤・ディナー</td>
              </tr>
              <tr>
                <td>ミディアム<br></br>W35 × H23 × D17 (cm)</td>
                <td>存在感と実用性</td>
                <td>★★★</td>
                <td>仕事・旅行・特別な日</td>
              </tr>
            </tbody>
          </table>
        </div>
        <span className="text-center">どのサイズにも共通するのは、"持つ人のスタイルを引き立てる"デザインであること。<br></br>
        トレンドではなく、タイムレスな美しさを求める大人の女性にこそ、5ACはふさわしい。</span>
        <div className="mt8">
          <h2>まとめ：あなたにぴったりの「5AC」は？</h2>
        </div>
        <p>同じマルジェラの5ACでも、サイズやカラーによって印象は大きく変わります。<br></br>
        アクセサリーのように軽やかに持ちたいなら【マイクロ】、<br></br>
        オンオフ問わず万能に使いたいなら【ミニ】、<br></br>
        荷物の多い日も安心して持てる存在感が欲しいなら【ミディアム】がおすすめです。<br></br>
        そして、定番のブラックはもちろん、淡いブルーやベージュなどのカラーも見逃せません。<br></br>
        冬の重たくなりがちなスタイルに“抜け感”をプラスしてくれる、シーズンレスな魅力があります。<br></br>
        あなたのスタイルに寄り添う「5AC」を選んで、自分らしいモードを楽しんでみてください。</p>
        <p className="mt4"><span className="text-border-bottom">マルジェラ5ACはどこで借りられる？</span></p>
        <p>価格も高額で、簡単には手に取りにくいマルジェラのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」──そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのブランドバッグを楽しめます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでメゾン マルジェラを体験しよう！</p>     
        <Link to="https://laxus.co/app/pc/bags/maisonmargiela" className="view-all-button">メゾン マルジェラのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post62

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 62}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`